import { render } from "./supplierDialog.vue?vue&type=template&id=35f8d806&scoped=true"
import script from "./supplierDialog.vue?vue&type=script&lang=js"
export * from "./supplierDialog.vue?vue&type=script&lang=js"

import "./supplierDialog.vue?vue&type=style&index=0&id=35f8d806&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35f8d806"]])

export default __exports__